"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestsForTestData = void 0;
var _cookie = require("./cookie");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var createBaseRequests = function createBaseRequests() {
  return {
    rest: {},
    gql: {}
  };
};
var cookieName = 'redux_query_store_requests_for_test_data';
var RequestsForTestData = /*#__PURE__*/_createClass(function RequestsForTestData() {
  var _this = this;
  _classCallCheck(this, RequestsForTestData);
  _defineProperty(this, "requests", createBaseRequests());
  _defineProperty(this, "getShouldStoreRequests", function () {
    return (0, _cookie.getCookie)(cookieName) === 'true' ? true : false;
  });
  _defineProperty(this, "getRequests", function () {
    return _this.requests;
  });
  _defineProperty(this, "clearRequests", function () {
    _this.requests = createBaseRequests();
  });
  _defineProperty(this, "addRequest", function (url, body, method, response) {
    if (_this.getShouldStoreRequests()) {
      var _query = null;
      var restUrl = url;
      if (body && body.hasOwnProperty('query')) {
        var bodyQuery = body.query;
        var firstNonQueryChar = bodyQuery.indexOf('(') !== -1 ? bodyQuery.indexOf('(') : bodyQuery.indexOf(' {');
        _query = bodyQuery.slice(6, firstNonQueryChar); // 6 because 'query '
        _this.requests.gql[_query] = {
          response: response
        };
      } else {
        restUrl = url.indexOf('?') !== -1 ? url.slice(0, url.indexOf('?')) : url;
        _this.requests.rest[restUrl] = {
          method: method,
          body: body,
          response: response
        };
      }
    }
  });
  if (this.getShouldStoreRequests()) {
    window.getRequestsForTestData = this.getRequests;
    window.clearRequestsForTestData = this.clearRequests;
  }
});
exports.RequestsForTestData = RequestsForTestData;